import "./myproject.css";
// import LinkImg from "../../img/link.png"
// import GithubImg from "../../img/github-icon.png"


const MyProject = ({img,link}) => {
  return (
    <div className="p">
      <div className="p-browser">
        <div className="p-circle"></div>
        <div className="p-circle"></div>
        <div className="p-circle"></div>
        {/* <span className="p-links">
          <a href="https://cryptoverse-reactapp.vercel.app/" target="_blank" rel="noreferrer"><img src={LinkImg} alt="project-link" /></a>
          <a href="https://github.com/Nitish105/CryptoVerse-reactapp" target="_blank" rel="noopener noreferrer"><img src={GithubImg} alt="github-link" /></a>
        </span> */}
      </div>
      <a href={link} target="_blank" rel="noreferrer">
        <img src={img} alt="" className="p-img" />
      </a>
    </div>
  );
};

export default MyProject;